export default {
	//返回36位不重复Guid码
	//通过this.$util.Guid.getGuid()使用
	getGuid() { 
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0,
				v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		})
	},	

}
